// 題目「已驗證」旗標：verified、verifiedHash（驗證當下的內容雜湊）、verifiedAt、verifiedBy
// 內容被修改後雜湊對不上，旗標自動失效，不會出現「已驗證但內容其實改過」。
// scripts/lib/verify.mjs 有同一份演算法（腳本寫入用），兩邊必須一致，測試向量見 verify.test.ts
export type VerifiableItem = {
  t?: string; q?: string; o?: unknown; a?: number; e?: string; p?: unknown; passage?: string; img?: string; audio?: string;
  verified?: boolean; verifiedHash?: string; verifiedAt?: string; verifiedBy?: string;
};

// 鍵值排序後序列化，避免 Firestore 回傳的欄位順序影響雜湊
const canon = (v: unknown): string =>
  Array.isArray(v) ? `[${v.map(canon).join(',')}]`
  : v && typeof v === 'object' ? `{${Object.keys(v as object).sort().map(k => `${JSON.stringify(k)}:${canon((v as Record<string, unknown>)[k])}`).join(',')}}`
  : JSON.stringify(v ?? null);

// cyrb53：53 位元字串雜湊，轉成 14 位 16 進位
function cyrb53(str: string): string {
  let h1 = 0xdeadbeef, h2 = 0x41c6ce57;
  for (let i = 0; i < str.length; i++) {
    const ch = str.charCodeAt(i);
    h1 = Math.imul(h1 ^ ch, 2654435761);
    h2 = Math.imul(h2 ^ ch, 1597334677);
  }
  h1 = Math.imul(h1 ^ (h1 >>> 16), 2246822507) ^ Math.imul(h2 ^ (h2 >>> 13), 3266489909);
  h2 = Math.imul(h2 ^ (h2 >>> 16), 2246822507) ^ Math.imul(h1 ^ (h1 >>> 13), 3266489909);
  return (4294967296 * (2097151 & h2) + (h1 >>> 0)).toString(16).padStart(14, '0');
}

// 內容雜湊：只看會影響「對不對」的欄位（題型、題目、選項、答案、解說、配對、閱讀文章、圖片、音訊）
export const contentHash = (x: VerifiableItem): string =>
  cyrb53(canon([x.t ?? null, x.q ?? '', x.o ?? null, x.a ?? null, x.e ?? '', x.p ?? null, x.passage ?? '', x.img ?? '', x.audio ?? '']));

export const isVerified = (x: VerifiableItem): boolean => x.verified === true && x.verifiedHash === contentHash(x);

// 寫入用：驗證通過時回傳要寫入的旗標欄位
export const verifiedFields = (x: VerifiableItem, by?: string): Pick<VerifiableItem, 'verified' | 'verifiedHash' | 'verifiedAt' | 'verifiedBy'> => ({
  verified: true, verifiedHash: contentHash(x), verifiedAt: new Date().toISOString().slice(0, 10), ...(by ? { verifiedBy: by } : {}),
});
